export default __webpack_public_path__ + "static/media/al-3.3a269410.jpg";